/* eslint-disable react/prop-types */
import React from "react";

import styled from "styled-components";

import Logo from "./Logo";

const Header = styled.header`
  display: flex;

  justify-content: flex-start;
  box-sizing: border-box;

  @media only screen and (max-width: 940px) {
    justify-content: flex-start;
    padding: 24px 56px 0 0;
  }
`;

const Link = styled.a`
  text-decoration: none;
  &:after {
    content: none;
  }
`;

const NavBar = ({ className, color }) => {
  return (
    <Header className={className}>
      <Link className="logo" href="/">
        <Logo color={color} />
      </Link>
    </Header>
  );
};

export default NavBar;
